import {
  Button,
  DialogContent,
  DialogActions,
  Stack,
  Typography,
  useTheme,
  Box,
} from "@mui/material";
import { FormTextField } from "components/Forms/FormTextField";
import { RadioGroupField } from "components/Forms/RadioGroupField";
import { SaveButton } from "components/SaveButton";
import { CaSections, SectionLabels } from "encamp-shared/src/hmbp/sections";
import { useFormContext } from "react-hook-form";
import { Fragment } from "react/jsx-runtime";

import { useReportIsVerified } from "../../../useReportIsVerified";

type ProvidedElsewhereProps = {
  handleBack: () => void;
  loading?: boolean;
};

export function ProvidedElsewhere({ loading, handleBack }: ProvidedElsewhereProps) {
  const theme = useTheme();
  const { control, watch } = useFormContext();
  const isVerified = useReportIsVerified();

  const suppliedIn: CaSections | null = watch("suppliedIn");
  const explanation: string | null = watch("explanation");

  return (
    <Fragment>
      <DialogContent sx={{ paddingTop: 2 }}>
        <Typography variant="body1" marginBottom={theme.spacing(2)}>
          Provided Elsewhere in CERS
        </Typography>

        <Typography variant="body2" marginBottom={theme.spacing(2)}>
          If requirements for this supplemental documentation can be satisfied by another document
          you have provided in CERS, please indicate the submittal element where the document can be
          found and provide the submittal date or other comments to assist your regulator in
          locating this document in your current/previous CERS facility submittals.
        </Typography>

        <RadioGroupField
          control={control}
          name="suppliedIn"
          label="Supplied in Submittal Element"
          direction="column"
          radioOptions={Object.values(CaSections).map((key) => ({
            value: key,
            label: SectionLabels[key],
          }))}
        />

        <Box marginTop={isVerified ? theme.spacing(2) : 0}>
          <FormTextField
            control={control}
            name="suppliedInExplanation"
            label="Indicate submittal date and/or other explanation"
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Stack direction="row" gap={theme.spacing(2)} justifyContent="flex-end">
          <Button onClick={handleBack}>{isVerified ? "Done" : "Back to Document Options"}</Button>
          {!isVerified && (
            <SaveButton
              loading={loading ?? false}
              disabled={suppliedIn === null || explanation === null}
            />
          )}
        </Stack>
      </DialogActions>
    </Fragment>
  );
}
